import React, { Component } from 'react';
import './globalSearch.css';
import SearchIcon from '@mui/icons-material/Search';
import { IconButton, Grid, TextField, FormControl, DialogActions, Button, Alert, Autocomplete, CircularProgress, FormControlLabel, Checkbox, Stack, Typography, Switch, Tooltip } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import { MultiSelect } from '../form-select/multi-select';
import api from '../../service/api';
import Result from '../result/result';
import ProgressBar from '../progress/progressBar';
import AdvanceForm from '../advance-search/advance-search';
import UserContext from '../../context/user';
import Storage from '../../session/storage';
import CONSTANT from '../../Constant/Constant';
import ConfirmationDialogRaw1 from './popupGlobal'
import PopUpMsg from '../merge-profile/popUpMsg'
import ProfileIcon from '../shared/ProfileIcon';
import popUpMessage from "../../config/popUpMsg.json";
import employerPopupConfig from '../../config/EmployerPopupConfig.json'
import styled from '@emotion/styled';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const Android12Switch = styled(Switch)(({ theme }) => ({
  padding: 8,
  '& .MuiSwitch-track': {
    borderRadius: 22 / 2,
    '&::before, &::after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 16,
      height: 16,
    },
    '&::before': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main),
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 12,
    },
    '&::after': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main),
      )}" d="M19,13H5V11H19V13Z" /></svg>')`,
      right: 12,
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 16,
    height: 16,
    margin: 2,
  },
}));


export default class GlobalSearch extends Component {
    static contextType = UserContext;
    constructor(props) {
        super(props);
        this.state = {
            form: {
                searchtext: '',
                searchtextFlag: false,
                country: [],
                entity: []
            },
            interval: undefined,
            parent: 'home',
            open: false,
            dualSearch: false,
            filter: '',
            showWarning: false,
            loading: false,
            typeLoading: false,
            elasticSearchCount: Storage.getCount() ? Storage.getCount() : 0,
            showReasulcomponent: false,
            showReasult: { total: 0, result: [] },
            showAdvanceSearch: false,
            popUpMsgData: popUpMessage.globalSearch,
            options: [],
            popUpMessage: {},
            noAccess: false,
            vendorSearch: true,
            showAccessPop: false,
            showIqviaPopUp: false,
            showNewHcoPopUp: false,
            selectedCountryForDcr: '',
            buttonKeyValue: ['HCP', 'HCO', 'Employer'],
            buttonSelected: '',
            selectList: [{ label: 'Entity', labelValue: ['HCP', 'HCO'] }, { label: 'Country', labelValue: Storage.getPickList() ? [...new Set([...Storage.getPickList()['HCP'].Country, ...Storage.getPickList()['HCO'].Country])] : [] }],
            // pagelabels: translate[localStorage.getItem('language') === null ? 'English' : localStorage.getItem('language')]
            isEmployer: false,
            userData: Storage.getUserData()
        }
        this.handleSearchText = this.handleSearchText.bind(this);
        this.handleEntity = this.handleEntity.bind(this);
        this.checkKey = this.checkKey.bind(this);
        let stateStorage = Storage.getGlobalName();
        let setcookies = JSON.parse(JSON.stringify(this.state));
        if (stateStorage !== undefined) {
            this.state = stateStorage;
            setcookies.form = stateStorage.form;
        }
        Storage.setHomePageState(setcookies);

    }



    async getCountry() {

        await api.getSelectedDCRCountry().then((countryList) => {

            Storage.setAllCountryList(countryList.data)
            var countryListData = countryList.data.map((el) => { return el })
            var vendorCountry = countryListData.filter((arr) => { return !arr.includes('#IQVIA' || '#Veeva Network') })
            this.setState({ lillyCountry: vendorCountry })
            this.setState({ lillySelectedCountry: countryListData })

        }).catch((error) => {


            let errorDetail = error;
            let msg = errorDetail.response ? errorDetail.response.data.errorCode : 'Internal Server Error!';

        })
        window.scroll(0, 0)


    }

    componentDidMount() {
        this.getCountry()
    }


    /**
     * Type head top values
     * @param {*} value 
     */
    async getTopResult(value) {
        const user = this.context;
        let country = [];
        let entity = [];
        this.state.form.entity?.map(res => {
            entity.push(res.name);
            return [];
        });
        this.state.form.country?.map(res => {
            country.push(res.name)
            return [];
        });

        country = country.length === 0 ? user.countries : country;
        let active = true;
        this.setState((oldValue) => {
            return {
                ...oldValue,
                typeLoading: true,
                options: []
            }
        })
        let intervalId = setTimeout(
            () => {
                (async () => {
                    let detailsType = [];
                    value.length !== 0 && await api.getGlobalSearch(entity, value, country, this.state.isEmployer ? 'Employer' : undefined, CONSTANT.TYPE_HEAD_COUNT_GLOBAL).then((res) => {
                        detailsType = [...JSON.parse(JSON.stringify(res?.data?.result)), { _id: "1243", _source: { secondaryLabel: 'View all', label: " [ " + value, link: " ]" } }];

                        if (active) {
                            this.setState((oldState) => {
                                return {
                                    ...oldState,
                                    options: detailsType,
                                    typeLoading: false
                                }
                            })
                        }
                    })
                })();

            }, 1000);
        this.setState((oldState) => {
            return {
                ...oldState,
                interval: intervalId
            }
        })

    }

    /**
     * handle search text change
     * @param {*} value 
     */
    async handleSearchText(value) {


        if (value.target.value.length > 3) {
            if (this.state.interval !== undefined) {
                clearTimeout(this.state.interval);
            }
            this.getTopResult(value.target.value)
        } else {
            if (this.state.interval !== undefined) {
                clearTimeout(this.state.interval);
            }
            this.setState((old) => ({ ...old, typeLoading: false, options: [] }))
        }

        await this.setState((oldValue) => {
            return {
                ...oldValue,
                showWarning: false,
                form: {
                    ...oldValue.form,
                    searchtext: value.target.value,
                    searchtextFlag: false,
                }
            }
        });
        let setcookies = JSON.parse(JSON.stringify(this.state));
        Storage.setHomePageState(setcookies);
    }

    /**
     * handle Entity change
     * @param {*} value 
     * @param {*} name 
     */
    async handleEntity(value, name) {
        await this.setState((oldValue) => {
            return {
                ...oldValue,
                showWarning: false,
                options: [],
                form: {
                    ...oldValue.form,
                    [name]: value
                }
            }
        });
        let setcookies = JSON.parse(JSON.stringify(this.state));
        Storage.setHomePageState(setcookies);
    }

    /**
     * Gandle Submit
     * @param {*} event 
     */
    async handleSubmit(event) {
        clearTimeout(this.state.interval);
        const user = this.context;
        await this.setState({ showWarning: false, typeLoading: false })
        this.state.form.searchtext.trim();
        const setcookies = JSON.stringify(this.state);
        Storage.setGlobalName(JSON.parse(setcookies));
        if (this.state.form.searchtext?.length !== 0) {
            this.setState({
                loading: true
            })
            let country = [];
            let entity = [];
            this.state.form.entity?.map(res => {
                entity.push(res.name);
                return [];
            });
            this.state.form.country?.map(res => {
                country.push(res.name)
                return [];
            });

            country = country.length === 0 ? user.countries : country;
            api.getGlobalSearch(entity, this.state.form.searchtext, country, this.state.isEmployer ? 'Employer' : undefined)
                ?.then((res) => {

                     this.setState({
                        showReasult: { total: res.data.total, result: res.data.result },
                        loading: false,
                        showWarning: true,
                        showReasulcomponent: (res.data.result.length === 0) ? false : true,
                        typeLoading: false
                    }, () => {
                        this.setStateCookie();
                        Storage.setAdvanceName(undefined);
                    });
                }).catch((err) => {
                    this.setState({
                        loading: false,
                        showWarning: true
                    })
                })
            api.getGlobalSearchCount(entity, this.state.form.searchtext, country, this.state.isEmployer ? 'Employer' : undefined)
                ?.then((res) => {
                    Storage.setCount(res.data.total.count);
                    this.setState((oldState) => {
                        return {
                            ...oldState,
                            elasticSearchCount: res.data.total.count
                        }
                    });
                }).catch((err) => {
                    this.setState((oldState) => {
                        return {
                            ...oldState,
                            elasticSearchCount: 0
                        }
                    });
                })
        } else {
            this.setState((prevState) => ({
                form: {
                    searchtext: prevState.form.searchtext,
                    searchtextFlag: true,
                    entity: prevState.form.entity
                }
            }));
        }
    }

    /**
     * Changes advance flag State
     */
    changeAdvanceFlag() {
        this.setState((oldState) => {
            return {
                ...oldState,
                showAdvanceSearch: !oldState.showAdvanceSearch
            }
        })
    }

    /**
     * set state to home
     */
    changeToDefault() {
        this.setState({
            showReasulcomponent: !this.state.showReasulcomponent
        })
    }

    /**
     * shows detail page of HCO or HCP
     * @param {*} details 
     */
    goToDetails(details) {



        const query = details._id + '/' + details._source?.type.split('/')[2];
        this.props.history.push("/details/" + query);
    }

    /**
     * If clicked on enter then submit the search
     * @param {*} event 
     */
    checkKey(event) {
        if (event.key === 'Enter') {
            this.handleSubmit();
        }
    }

    /**
     * show's advance form
     */
    showAdvanceSearch() {
        this.setState((oldState) => {
            return { ...oldState, parent: 'global', dualSearch: true }
        });
        this.changeAdvanceFlag();

    }

    /**
     * SHow's Result Page
     */
    showResult() {
        this.setState((oldState) => {
            return {
                ...oldState,
                showAdvanceSearch: false,
                showReasulcomponent: true
            }
        })
    }
    /**
     * pop up open and close
    */
    openPopUp(vendorValue, entityType) {
        this.setState((prevState) => ({ buttonSelected: entityType }))
        this.setState({ buttonSelected: entityType })
        if (this.props.user.countries.includes('global')) {

            this.accessCountry = this.state.lillySelectedCountry.sort((a) => {

                if (a.split('#')[1] != 'IQVIA')

                    return 1;

                else if (a.split('#')[1] == 'IQVIA')
                    return -1;

                else
                    return 0;
            }).sort((a, b) => {

                return ((a.split('#')[1] < b.split('#')[1] ? -1 : 1))
            })

            this.vendorStatus = vendorValue

            this.setState({ showAccessPop: true, showIqviaPopUp: true, entityType: entityType })

        }
        else if (this.props.user.countries.length >= 1) {


            this.accessCountry = this.state.lillySelectedCountry.filter((el) => { return this.props.user.countries.some((arr) => el.includes(arr)) })

            if (vendorValue && this.accessCountry.filter((el) => { return el.includes('#IQVIA') }).length == 0) {
                this.setState(prevState => ({ popUpMessage: { heading: prevState.popUpMsgData[0].noVendorCountry.heading, message: prevState.popUpMsgData[0].noVendorCountry.description, onClose: 'Confirm' } }))
                this.setState({ noAccess: true })

            }
            else {
                this.vendorStatus = vendorValue
                this.setState({ showAccessPop: true, showIqviaPopUp: true, entityType: entityType })
            }


        }
        else {

            this.setState({ popUpMessage: { heading: 'Error', message: 'Something went wrog. Please try again later.', onClose: 'Close' }, showAccessPop: false, showIqviaPopUp: false, noAccess: true })

        }
    }

    handleOk(value) {
        this.setState({ showIqviaPopUp: false, noAccess: false, showAccessPop: false, selectedCountryForDcr: value })
    };

    cancelPopUp() {
        this.setState({ showIqviaPopUp: false, showNewHcoPopUp: false, noAccess: false, showAccessPop: false, selectedCountryForDcr: '' })
    }

    /**
     * maintain Session
     */
    setStateCookie() {
        const setcookies = JSON.stringify(this.state);
        Storage.setGlobalName(JSON.parse(setcookies));
    }

    /**
     * Back to home state
     */
    home() {
        this.setState(Storage.getHomePageState());
        this.setState((oldState) => {
            return {
                ...oldState,
                typeLoading: false,

                options: []
            }
        })
    }

    handleOpen() {
        this.setState((oldState) => {
            return {
                ...oldState,
                open: true
            }
        })
    }

    handleClose() {
        this.setState((oldState) => {
            return {
                ...oldState,
                open: false
            }
        })
    }
    /**
     * Set Global Page session
     */
    setGlobalSessionParent() {
        this.setState((oldState) => {
            return { ...oldState, parent: 'global' }
        });
        this.setStateCookie();
    }

    // Employer Search
    updateEmployerSearch(ischecked) {
        if (ischecked) {
            this.setState({
                isEmployer: ischecked
            })
        }
    }

    render() {
        return (
            <>
                {
                    this.state.showIqviaPopUp && this.state.showAccessPop &&
                    <div className="container d-flex justify-content-center">
                        <ConfirmationDialogRaw1
                            searchText={this.state.form.searchtext}
                            id="static-popup"
                            open={this.state.showIqviaPopUp}
                            onOk={(value) => this.handleOk(value)}
                            onCancel={() => this.cancelPopUp()}
                            option={this.accessCountry}
                            vendor={this.vendorStatus}
                            entityType={this.state.entityType}
                            specialtyDropDownvalue={Storage.getPickList().specialty_cnt}
                            user={this.props.user}
                            entity={this.state.buttonSelected}
                            selectedCountry={this.state.buttonSelected === 'Employer' ? employerPopupConfig.raw_countries.filter((option) => option === 'United States') : null}
                        />
                    </div>

                }
                {this.state.showIqviaPopUp && this.state.noAccess &&
                    <PopUpMsg

                        popUpMessage={this.state.popUpMessage}
                        onClose={() => this.cancelPopUp()}
                    />
                }



                {
                    this.state.showAdvanceSearch &&
                    <AdvanceForm
                        dualSearch={this.state.dualSearch}
                        globalForm={this.state.form}
                        parent={this.state.parent}
                        setGlobalSession={() => this.setGlobalSessionParent()}
                        showResult={() => this.showResult()}
                        showAdvanceSearch={() => this.showAdvanceSearch()}
                        getBackToHome={() => this.home()}
                        history={this.props.history}
                        lillyCountry={this.state.lillyCountry}
                        vendorSearch={(data) => this.openPopUp(data)}
                    />

                }
                {
                    !this.state.showAdvanceSearch &&
                    <section className={!this.state.showReasulcomponent ? "container body-height extra-margin-top" : "container body-height extra-margin-top-less"}>


                        {
                            !this.state.showReasulcomponent
                            &&
                            <form className="extra-margin-top container-fluid row d-flex justify-content-center " >
                                {
                                    this.state?.userData?.isEmployerAccess && 
                                    <div className="col-12 mt-5 w-full min-width">
                                        <Grid container alignItems="flex-center text-center">
                                            <Grid item md={12} xs={12} className="d-flex justify-content-center">
                                                <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                                                        <Tooltip title={"Allows searching across all commercial data for entity types HCP and HCO."}>
                                                                <InfoOutlinedIcon fontSize='small' color='error' className='pb-.5'/>
                                                        </Tooltip>
                                                        <Typography>Global Search</Typography>
                                                    <Android12Switch 
                                                        defaultChecked={this.state.isEmployer}
                                                        onChange={(event) => {
                                                            this.handleEntity([], 'country')
                                                            this.setState({ isEmployer: event.target.checked })
                                                        }}
                                                        value={this.state.isEmployer}
                                                    />
                                                    <Typography>Employer only Search</Typography>
                                                    <Tooltip title={"Restricts results to Employer customer type for entity type HCP and HCO."}>
                                                        <InfoOutlinedIcon fontSize='small' color='error' className='mx-1.1 pb-.5'/>
                                                    </Tooltip>
                                                </Stack>
                                                {/* <FormControlLabel
                                                    sx={{
                                                        margin: 0
                                                    }}
                                                    control={<Checkbox defaultChecked={this.state.isEmployer} value={this.state.isEmployer} />}
                                                    label="Employer Search"
                                                    onChange={(event) => {
                                                        this.handleEntity([], 'country')
                                                        this.setState({ isEmployer: event.target.checked })
                                                    }}
                                                /> */}
                                            </Grid>
                                        </Grid>
                                    </div>
                                }
                                <div className="col-12 mt-2 w-80 min-width">
                                    <Grid container spacing={1} alignItems="flex-end">
                                        <Grid item md={7} xs={7}>
                                            <Autocomplete
                                                id="search-text"
                                                // id={this.state.pagelabels.search}
                                                freeSolo
                                                value={this.state.form.searchtext}
                                                disableClearable
                                                className='mt-0'
                                                disabled={this.state.loading}
                                                open={this.open}
                                                onOpen={() => this.handleOpen}
                                                onClose={() => this.handleClose}
                                                renderOption={(props, option, selected) => (

                                                    <React.Fragment key={option?._id}>
                                                        {
                                                            option?._source?.link !== undefined && <span className='text-primary ms-2' {...props} onClick={(event) => this.handleSubmit(event)}>{option?._source?.secondaryLabel}{option?._source?.label}{option?._source?.link}</span>}
                                                        {
                                                            option?._source?.link === undefined &&
                                                            <React.Fragment key={option?._id}  >


                                                                <div className="ms-2" key={option._id} {...props} onClick={() => this.goToDetails(option)}>
                                                                    <ProfileIcon
                                                                        type={option._source.type !== undefined && option._source.type.split('/')[2]}
                                                                        sx={{ height: '40px', width: '40px', marginRight: '10px' }}
                                                                    />
                                                                    <span>{option?._source?.label}, <span className='text-muted'>{option?._source?.secondaryLabel}</span> </span>
                                                                </div>
                                                                {/* <DoneIcon
                                                                    style={{ visibility: selected ? 'visible' : 'hidden' }}
                                                                /> */}
                                                            </React.Fragment>
                                                        }
                                                    </React.Fragment>

                                                )
                                                }
                                                getOptionLabel={(option) => {
                                                    if (option._source !== undefined) {
                                                        return option._source.label;
                                                    } else {
                                                        return option;
                                                    }
                                                }
                                                }
                                                options={this.state.options}
                                                filterOptions={(options, state) => options}
                                                isOptionEqualToValue={(option, value) => {

                                                    if (option !== undefined && option.source !== undefined) {
                                                        return option._source.label === value._source.label
                                                    } else {
                                                        return false;
                                                    }
                                                }}
                                                loading={this.state.typeLoading}
                                                renderInput={(params) => (
                                                    <TextField
                                                        variant="standard"
                                                        value={this.state.form.searchtext || ''}
                                                        {...params}

                                                        onKeyDown={this.checkKey}
                                                        error={this.state.form.searchtextFlag}
                                                        helperText={this.state.form.searchtextFlag ? "Please Enter Something" : " "}
                                                        onChange={this.handleSearchText} id="input-with-icon-grid"
                                                        color="primary" className="w-100 search-text" label="Search"
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            endAdornment: (
                                                                <React.Fragment>
                                                                    {this.state.typeLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                                                    {params.InputProps.endAdornment}
                                                                </React.Fragment>
                                                            ),
                                                        }}
                                                    />
                                                )}
                                            />
                                        </Grid>

                                        <Grid item md={2} xs={2}>
                                            <FormControl className="w-100" id="search-text">
                                                <MultiSelect
                                                    name='Entity'
                                                    // name={this.state.pagelabels.entity}
                                                    disabled={this.state.loading}
                                                    selectList={[this.state.selectList[0]]}
                                                    entity={this.state.form.entity}
                                                    changedEntity={(entity) => this.handleEntity(entity, 'entity')} />
                                            </FormControl>
                                        </Grid>
                                        <Grid item md={2} xs={2}>
                                            <FormControl className="w-100">
                                                <MultiSelect
                                                    name='Country'
                                                    // name={this.state.pagelabels.country}
                                                    disabled={this.state.loading}
                                                    selectList={this.state.isEmployer ? [employerPopupConfig?.globalSearchCountries] : [this.state.selectList[1]]}
                                                    entity={this.state.form.country}
                                                    changedEntity={(entity) => this.handleEntity(entity, 'country')} />
                                            </FormControl>
                                        </Grid>
                                        <Grid item md={1} xs={1}>
                                            {
                                                <IconButton onClick={(event) => this.handleSubmit(event)} disabled={this.state.loading} className="MyCustomButton mb-4 black " aria-label="search">
                                                    <SearchIcon />
                                                </IconButton>
                                            }
                                        </Grid>


                                    </Grid>
                                </div>
                            </form>
                        }

                        {
                            !this.state.showReasulcomponent && !this.state.isEmployer
                            &&
                            <div className="d-flex justify-content-center">


                                <DialogActions sx={{ float: 'left', mt: '10px' }} id="vendor-button">
                                    <Button
                                        className='advanceSearch'
                                        disableElevation
                                        id="search-text"
                                        color="error"
                                        onClick={() => this.changeAdvanceFlag()}
                                        variant="contained"

                                    >
                                        <AddCircleOutlineIcon style={{ marginRight: '10px', marginLeft: '10px' }} />
                                        <span id="search-text" >Advanced Search</span>
                                    </Button>
                                </DialogActions>




                            </div>
                        }

                        {
                            this.state.loading &&
                            <div className="d-flex justify-content-center">
                                <ProgressBar />
                            </div>
                        }
                        {
                            (this.state.showReasult.result.length === 0 && this.state.showWarning) &&
                            <>
                                <div className="container d-flex justify-content-center" id="search-text">
                                    <Alert severity="warning" className="w-70 justify-content-center text-center" color="info">
                                        <span>  <strong>0</strong> Records Found in EPH. <Button className='linkButton' onClick={() => this.openPopUp(this.state.vendorSearch)}> Click here to Search in Vendor</Button ></span><br />OR <br />
                                        <Button className='linkButton' onClick={() => this.openPopUp(!this.state.vendorSearch, this.state.buttonKeyValue[0])}> Add New HCP</Button > {" | "}
                                        <Button className='linkButton' onClick={() => this.openPopUp(!this.state.vendorSearch, this.state.buttonKeyValue[1])}> Add New HCO</Button >
                                        {this.state?.userData?.isEmployerAccess && <> {" | "}<Button className='linkButton' onClick={() => this.openPopUp(!this.state.vendorSearch, this.state.buttonKeyValue[2])}> Add New Employer</Button ></>}
                                    </Alert>
                                </div>
                            </>
                        }


                        {
                            (
                                this.state.showReasult.result.length > 0
                                &&
                                this.state.showReasulcomponent
                            )
                            &&
                            <Result parent='globalState' form={this.state.form}
                                result={this.state.showReasult.result}
                                count={this.state.elasticSearchCount}
                                getback={() => this.changeToDefault()}
                                goToDetails={(details) => this.goToDetails(details)}
                                showAdvanceSearch={() => this.showAdvanceSearch()}
                                vendorSearch={(data) => this.openPopUp(data)}
                                lillyCountry={this.state.lillyCountry}
                                goToHome={() => this.home()}
                                history={this.props.history}
                                user={this.props.user}
                                isEmployer={this.state.isEmployer}
                            />
                        }
                    </section >

                }
            </>
        );
    }
}